/* Pegasus — revelado al hacer scroll, filtros y añadir a la cesta sin recargar */
(function () {
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!reduce && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -10% 0px' });
    document.querySelectorAll('.pg [data-reveal]').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('.pg [data-reveal]').forEach(function (el) { el.classList.add('is-in'); });
  }

  document.querySelectorAll('[data-pg-filter]').forEach(function (bar) {
    var grid = document.getElementById(bar.dataset.pgFilter);
    if (!grid) return;
    bar.addEventListener('click', function (e) {
      var b = e.target.closest('.pg-chip'); if (!b) return;
      bar.querySelectorAll('.pg-chip').forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
      var k = b.dataset.cat;
      grid.querySelectorAll('.pg-card').forEach(function (c) {
        c.hidden = !(k === 'todo' || (c.dataset.cat || '').indexOf(k) > -1);
      });
    });
  });

  function bubble() {
    var n = document.querySelector('[data-pg-count]');
    if (!n) return;
    n.textContent = (parseInt(n.textContent, 10) || 0) + 1;
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-pg-add]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('button');
    var old = btn.textContent;
    btn.disabled = true;
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(form.dataset.pgAdd), quantity: 1 }] }) })
      .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
      .then(function () {
        btn.textContent = 'Añadido';
        bubble();
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        setTimeout(function () { btn.textContent = old; btn.disabled = false; }, 1600);
      })
      .catch(function () { btn.textContent = 'No disponible'; setTimeout(function () { btn.textContent = old; btn.disabled = false; }, 1600); });
  });
})();
